<div class="accordion" id="accordionExample" style="margin-top: -25px;">

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Dividendbelasting box 3
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul het bedrag in van de Nederlandse dividendbelasting die werd ingehouden in {{ this.year }} . Je vindt
                dit bedrag op de overzichten van de financiële instellingen waar je de beleggingen hebt.
                <div class="space10"></div>

                Vul hier ook de ingehouden Nederlandse dividendbelasting in van een minderjarig kind van wie je het
                vermogen aangeeft.
                <div class="space10"></div>

                Je mag het totaal afronden in je voordeel. Was de ingehouden dividendbelasting bijvoorbeeld € 345,34?
                Dan mag je € 346 invullen.
                <div class="space10"></div>

                <b>Niet hier invullen</b><br/>
                Vul hier niet Nederlandse dividendbelasting op dividend in dat je hebt ontvangen uit:
                <li class="list">een lijfrentebeleggingsrecht</li>
                <li class="list">een beleggingsrecht eigen woning</li>
                <li class="list">een stamrechtbeleggingsrecht</li>
                <li class="list">een aanmerkelijk belang</li>
                <div class="space10"></div>

                Had je in {{ this.year }} een fiscale partner? Vul dan de ingehouden dividendbelasting in van jou en je
                fiscale
                partner samen. Ook als je niet samen aangifte doet, moet je de dividendbelasting van jou en de fiscale
                partner samen invullen.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse" aria-expanded="false" aria-controls="collapse">
                Dividendbelasting box 2
            </button>
        </h2>
        <div id="collapse" class="accordion-collapse collapse" aria-labelledby="heading"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul de dividendbelasting in die in {{ this.year }} is ingehouden op je dividend(en) uit aanmerkelijk
                belang.
                <div class="space10"></div>
                Op het moment dat je dividend krijgt, wordt er dividendbelasting ingehouden. Op je dividendnota staat
                welk bedrag dit is.
            </div>
        </div>
    </div>

</div>



